import { useState } from "react";
import { useT } from "../i18n";
import { canUseSentryDevTools, captureSentryVerificationMessage } from "../sentryDev";

/** Render-phase throw so Sentry.ErrorBoundary shows the fallback (click handlers do not). */
function SentryVerificationCrash(): never {
  throw new Error("Sentry verification crash (intentional)");
}

export function SentryDevToolsCard() {
  const { t } = useT();
  const [crash, setCrash] = useState(false);
  const [sent, setSent] = useState(false);

  if (!canUseSentryDevTools()) return null;
  if (crash) return <SentryVerificationCrash />;

  return (
    <div className="card">
      <h2>{t("admin.settings.sentryDevTitle")}</h2>
      <p className="muted small">{t("admin.settings.sentryDevBody")}</p>
      {sent ? <p className="small" style={{ color: "var(--success, #0a7)" }}>{t("admin.settings.sentryTestSent")}</p> : null}
      <div className="toolbar" style={{ gap: 8 }}>
        <button
          type="button"
          className="btn secondary small"
          onClick={() => {
            captureSentryVerificationMessage();
            setSent(true);
          }}
        >
          {t("admin.settings.sentryTestMessage")}
        </button>
        <button type="button" className="btn secondary small" onClick={() => setCrash(true)}>
          {t("admin.settings.sentryTestCrash")}
        </button>
      </div>
    </div>
  );
}
